module.exports = __webpack_public_path__ + "std/img/deposit-list-bar.b425cd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/common/deposit-list-bar.png
// module id = 57/1
// module chunks = 0